import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  DateUtilsService,
  DEFAULT_MONTHS,
  type MonthOption,
} from '../../../services/date-utils.service';



@Component({
  selector: 'app-periodo-mensual',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './periodo-mensual.component.html',
  styleUrls: ['./periodo-mensual.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeriodoMensualComponent implements OnInit {
  @Input() years: number[] = [];
  @Input() months: MonthOption[] = [];
  /** ISO `yyyy-MM-dd` o vacío */
  @Input() maxDate: string | null = null;
  /** ISO `yyyy-MM-dd` o vacío; si es `null`/vacío se usa la mínima del sistema */
  @Input() minDate: string | null = null;

  @Input() selectedYear: number | null = null;
  @Output() selectedYearChange = new EventEmitter<number | null>();

  @Input() selectedMonth: MonthOption | null = null;
  @Output() selectedMonthChange = new EventEmitter<MonthOption | null>();

  constructor(private readonly dateUtilsService: DateUtilsService) {}

  ngOnInit(): void {
    const currentYear = this.dateUtilsService.getCurrentYear();
    const currentMonth = this.dateUtilsService.getCurrentMonthNumber();
    const minIso = this.dateUtilsService.getMinDate(this.minDate);
    const minYear = this.dateUtilsService.parseIsoToLocalDate(minIso).getFullYear();

    let maxYear: number;
    let maxMonth: number;
    if (this.maxDate?.trim()) {
      const maxD = new Date(this.maxDate.trim());
      if (!Number.isNaN(maxD.getTime())) {
        maxYear = maxD.getFullYear();
        maxMonth = maxD.getMonth() + 1;
      } else {
        maxYear = currentYear;
        maxMonth = currentMonth;
      }
    } else {
      maxYear = currentYear;
      maxMonth = currentMonth;
    }

    this.years = this.dateUtilsService.buildYearsRange(minYear, maxYear);

    if (!this.months.length) {
      this.months = [...DEFAULT_MONTHS];
    }

    const parentHadYear = this.selectedYear !== null;
    const parentHadMonth = this.selectedMonth !== null;

    if (this.selectedYear === null) {
      this.selectedYear = Math.min(
        Math.max(currentYear, minYear),
        maxYear,
      );
    }
    this.months = this.dateUtilsService.buildMonthsRange(
      this.selectedYear!,
      this.minDate,
    );

    if (this.selectedMonth === null) {
      this.selectedMonth =
        this.months.find((m) => m.number === currentMonth) ??
        this.months[this.months.length - 1] ??
        null;
    }

    // Evita NG0100: no actualizar el padre con [(ngModel)] durante el mismo ciclo de CD.
    if (!parentHadYear || !parentHadMonth) {
      queueMicrotask(() => {
        if (!parentHadYear) {
          this.selectedYearChange.emit(this.selectedYear);
        }
        if (!parentHadMonth) {          
          this.selectedMonthChange.emit(this.selectedMonth);
        }
      });
    }
  }

  onYearModelChange(value: number | null): void {
    this.selectedYear = value;
    this.selectedYearChange.emit(this.selectedYear);
    this.months = this.dateUtilsService.buildMonthsRange(this.selectedYear, this.minDate);
    this.selectedMonth = this.months[0];
    this.selectedMonthChange.emit(this.selectedMonth);
  }

  onMonthModelChange(value: MonthOption | null): void {
    this.selectedMonth = value;
    this.selectedMonthChange.emit(this.selectedMonth);
  }

}
